// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"baz_a","InstagramEmbed__mask":"baz_b bhs_bi bhs_bo bhs_vt"};